$(function(){
    $('.b-article-gallery').each(function(){
        var $context = $(this),
            sliderTotal = $('.b-article-gallery__total', $context),
            sliderExpand = $('.b-article-gallery__expand', $context),
            slider = $('.b-article-gallery__images', $context),
            settings = {
                slidesToShow: 2,
                slidesToScroll: 1,
                mobileFirst: true,
                dots: false,
                arrows: true,
                prevArrow:'<div class="b-slider-arrows__prev"><svg width="20" height="34" viewBox="0 0 20 34" xmlns="http://www.w3.org/2000/svg"><path d="M16.5859 33.4142L0.171665 17L16.5859 0.585788L19.4143 3.41422L5.82852 17L19.4143 30.5858L16.5859 33.4142Z"></path></svg></div>',
                nextArrow:'<div class="b-slider-arrows__next"><svg width="20" height="34" viewBox="0 0 20 34" xmlns="http://www.w3.org/2000/svg"><path d="M16.5859 33.4142L0.171665 17L16.5859 0.585788L19.4143 3.41422L5.82852 17L19.4143 30.5858L16.5859 33.4142Z"></path></svg></div>',
                swipeToSlide: true,
                lazyLoad: 'progressive',
                touchThreshold: 30,
                infinite: false,
                responsive: [
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 2
                        }

                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 3
                        }

                    }
                ]
            };
        slider.on('init', function(event, slick){
            slider.find('.b-article-gallery__item').each(function(){
                var slideItem = $(this);
                if (slideItem.tagName === 'A' && slideItem.attr('href').length < 1) {
                    slideItem.attr('href', slideItem.find('img').attr('src'))
                }
            });
            sliderTotal.text(slick.slideCount);
            sliderExpand.on('click', function(e){
                e.preventDefault();
                slider.find('[data-slick-index=0]').trigger('click');
            })
        });
        slider.slick(settings);

        $(window).on('resize', function() {
            if( $(window).width() < 1025 && !slider.hasClass('slick-initialized')) {
                slider.slick(settings);
            }
        });
        $("[data-fancybox=article-gallery]", $context).fancybox({
            backFocus: false,
            animationEffect: "fade"
        });
    })
})
